// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#menu {
  display: flex;
  flex-direction: column;
  background-color: var(--menu-bg-color);
  width: 3.5rem;
  min-width: 3.5rem;
  transition: min-width 400ms;
  box-shadow: var(--shadow);
  z-index: 3;
}

@media (max-width: 48rem) {

#menu {
    width: 100%;
    flex-direction: row;
    flex: 0 0 3.5rem;
}
  }

#menu.open {
    min-width: 12rem;
  }

#menu nav {
    display: flex;
    flex-direction: column;
    font-size: 0.75rem;
    flex: 0 0 3.5rem;
  }

@media (max-width: 48rem) {

#menu nav {
      flex-direction: row;
  }
    }

#menu nav a.active {
        background-color: var(--theme-light-color);
        color: var(--menu-color-active);
      }

#menu nav a:hover {
        background-color: var(--theme-color);
        color: var(--menu-color-active);
      }

#menu .icon {
    width: 3.5rem;
    text-align: center;
    display: inline-block;
  }

@media (max-width: 48rem) {

#menu .icon {
      width: 2.5rem;
  }
    }

#menu .text {
    display: inline-block;
  }

@media (max-width: 48rem) {

#menu .text {
      position: absolute;
      visibility: hidden;
  }
    }

#logo {
  display: flex;
  padding: 0.5rem;
  justify-content: flex-end;
  background-color: var(--shell-bg-color);
  z-index: 5;
  box-shadow: var(--shadow);
}

#logo img {
    width: 2.5rem;
    height: 2.5rem;
  }

#menu nav a, #menu-footer button {
  color: var(--menu-color);
  padding: 0.625rem 0;
  white-space:nowrap;
  overflow: hidden;
  flex: 0 0 1rem;
}

@media (max-width: 48rem) {

#menu nav a, #menu-footer button {
    padding: 0 0.625rem;
    flex-basis: 2.5rem;
    text-align: center;

    display: flex;
    flex-direction: column;
    justify-content: center;
}
  }

#menu-spacer {
  flex-grow: 1;
}

#menu-footer button {
  border: 0;
  background-color: transparent;
}

#menu-footer button svg {
    transition: 400ms;
  }

@media (max-width: 48rem) {
  #menu-spacer, #menu-footer {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./core/components/Menu.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,sCAAsC;EACtC,aAAa;EACb,iBAAiB;EACjB,2BAA2B;EAC3B,yBAAyB;EACzB,UAAU;AAqDZ;;AAnDE;;AAVF;IAWI,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AAgDpB;EA/CE;;AAEA;IACE,gBAAgB;EAClB;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;EAiBlB;;AAfE;;AANF;MAOI,mBAAmB;EAcvB;IAbE;;AAGE;QACE,0CAA0C;QAC1C,+BAA+B;MACjC;;AAEA;QACE,oCAAoC;QACpC,+BAA+B;MACjC;;AAIJ;IACE,aAAa;IACb,kBAAkB;IAClB,qBAAqB;EAKvB;;AAHE;;AALF;MAMI,aAAa;EAEjB;IADE;;AAGF;IACE,qBAAqB;EAMvB;;AAJE;;AAHF;MAII,kBAAkB;MAClB,kBAAkB;EAEtB;IADE;;AAIJ;EACE,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,uCAAuC;EACvC,UAAU;EACV,yBAAyB;AAM3B;;AAJE;IACE,aAAa;IACb,cAAc;EAChB;;AAGF;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAWhB;;AATE;;AAPF;IAQI,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;;IAElB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;AAE3B;EADE;;AAGF;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,6BAA6B;AAK/B;;AAHE;IACE,iBAAiB;EACnB;;AAGF;EACE;IACE,aAAa;EACf;AACF","sourcesContent":["#menu {\r\n  display: flex;\r\n  flex-direction: column;\r\n  background-color: var(--menu-bg-color);\r\n  width: 3.5rem;\r\n  min-width: 3.5rem;\r\n  transition: min-width 400ms;\r\n  box-shadow: var(--shadow);\r\n  z-index: 3;\r\n\r\n  @media (max-width: 48rem) {\r\n    width: 100%;\r\n    flex-direction: row;\r\n    flex: 0 0 3.5rem;\r\n  }\r\n\r\n  &.open {\r\n    min-width: 12rem;\r\n  }\r\n\r\n  & nav {\r\n    display: flex;\r\n    flex-direction: column;\r\n    font-size: 0.75rem;\r\n    flex: 0 0 3.5rem;\r\n\r\n    @media (max-width: 48rem) {\r\n      flex-direction: row;\r\n    }\r\n\r\n    & a {\r\n      &.active {\r\n        background-color: var(--theme-light-color);\r\n        color: var(--menu-color-active);\r\n      }\r\n\r\n      &:hover {\r\n        background-color: var(--theme-color);\r\n        color: var(--menu-color-active);\r\n      }\r\n    }\r\n  }\r\n\r\n  & .icon {\r\n    width: 3.5rem;\r\n    text-align: center;\r\n    display: inline-block;\r\n\r\n    @media (max-width: 48rem) {\r\n      width: 2.5rem;\r\n    }\r\n  }\r\n\r\n  & .text {\r\n    display: inline-block;\r\n\r\n    @media (max-width: 48rem) {\r\n      position: absolute;\r\n      visibility: hidden;\r\n    }\r\n  }\r\n}\r\n\r\n#logo {\r\n  display: flex;\r\n  padding: 0.5rem;\r\n  justify-content: flex-end;\r\n  background-color: var(--shell-bg-color);\r\n  z-index: 5;\r\n  box-shadow: var(--shadow);\r\n\r\n  & img {\r\n    width: 2.5rem;\r\n    height: 2.5rem;\r\n  }\r\n}\r\n\r\n#menu nav a, #menu-footer button {\r\n  color: var(--menu-color);\r\n  padding: 0.625rem 0;\r\n  white-space:nowrap;\r\n  overflow: hidden;\r\n  flex: 0 0 1rem;\r\n\r\n  @media (max-width: 48rem) {\r\n    padding: 0 0.625rem;\r\n    flex-basis: 2.5rem;\r\n    text-align: center;\r\n\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n  }\r\n}\r\n\r\n#menu-spacer {\r\n  flex-grow: 1;\r\n}\r\n\r\n#menu-footer button {\r\n  border: 0;\r\n  background-color: transparent;\r\n\r\n  & svg {\r\n    transition: 400ms;\r\n  }\r\n}\r\n\r\n@media (max-width: 48rem) {\r\n  #menu-spacer, #menu-footer {\r\n    display: none;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
